import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, catchError, delay, map, of, tap } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class GuestService {
  constructor(private http: HttpClient) {}
  baseUrl = `${environment.BASE_URL}`;
  private readonly GUEST_DETAILS_KEY = "iGuestDetails";
  private readonly GUEST_INFO = "iGuestInfo";
  private readonly draft_post = "iDraftPost";
  private readonly event_draft_post = "iEventDraftPost";
  private totalPages = 1;
  feedsSubject = new BehaviorSubject<any[]>([]);
  feeds$ = this.feedsSubject.asObservable();
  public loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();
  public noMoreFeedsSubject = new BehaviorSubject<boolean>(false);
  public noMoreFeeds$ = this.noMoreFeedsSubject.asObservable();

  public errorSubject = new BehaviorSubject<boolean>(false);
  error$ = this.errorSubject.asObservable();

  public publicFeedsSubject = new BehaviorSubject<any[]>([]);
  publicFeeds$ = this.publicFeedsSubject.asObservable();
  public publicLoadingSubject = new BehaviorSubject<boolean>(false);
  publicLoading$ = this.publicLoadingSubject.asObservable();

  public publicErrorSubject = new BehaviorSubject<boolean>(false);
  publicError$ = this.publicErrorSubject.asObservable();

  updatePublicFeeds(newFeed: any) {
    const currentFeeds = this.publicFeedsSubject.value;
    this.publicFeedsSubject.next([newFeed, ...currentFeeds]);
  }
  // /users/user-create-feed/33
  guestLogin(payload: any) {
    // const payload = { guestCode };
    return this.http.post<any>(`${this.baseUrl}/events/guestlogin`, payload);
  }
  validateOTP = (payload) =>
    this.http.post(`${environment.BASE_URL}/events/validate-guestotp`, payload);

  getTicketOTP = (payload) =>
    this.http.post(`${environment.BASE_URL}/events/get-ticket-otp`, payload);

  validateTicketOTP = (payload) =>
    this.http.post(
      `${environment.BASE_URL}/events/validate-ticket-otp`,
      payload
    );

  getGuestEvents(guestEmail): Observable<any> {
    const url = `${environment.BASE_URL}/events/guestevents/${guestEmail}`;
    return this.http.get<any>(url);
  }

  getGuestAttireOrders = (eventId, guestId, page, limit, status) => {
    let params = new HttpParams();
    params = params.append("eventId", eventId);
    params = params.append("guestId", guestId);
    params = params.append("page", page);
    params = params.append("limit", limit);
    params = params.append("status", status);
    return this.http.get(
      `${environment.BASE_URL}/events/event/attire/${guestId}/${eventId}`,
      {
        params,
      }
    );
  };
  resendTicketOTP = (payload) =>
    this.http.post(`${environment.BASE_URL}/events/resend-ticket-otp`, payload);

  resendGuestOTP = (payload) =>
    this.http.post(
      `${environment.BASE_URL}/events/resend-guestlogin-otp`,
      payload
    );

  getAllEvents = (eventType, page, limit) => {
    let params = new HttpParams();
    if (eventType !== "") {
      params = params.append("eventType", eventType);
    }
    if (page) {
      params = params.append("page", page);
    }
    if (limit) {
      params = params.append("limit", limit);
    }
    return this.http.get(`${environment.BASE_URL}/events`, { params });
  };

  getAllPublicFeeds(limit: number, page: number): void {
    let params = new HttpParams();
    params = params.append("limit", limit.toString());
    params = params.append("page", page.toString());
    this.publicLoadingSubject.next(true);
    this.publicErrorSubject.next(false);

    this.http
      .get<{ success: boolean; data: any[] }>(
        `${environment.BASE_URL}/feeds/public-feeds`,
        { params }
      )
      .pipe(
        map((response) => response.data || []),
        tap(() => this.publicLoadingSubject.next(false)),
        catchError((error) => {
          this.publicErrorSubject.next(true);
          this.publicLoadingSubject.next(false);
          throw error;
        })
      )
      .subscribe(
        (feeds) => {
          if (feeds.length === 0) {
            this.noMoreFeedsSubject.next(true);
          } else {
            this.noMoreFeedsSubject.next(false);
            const currentFeeds = this.publicFeedsSubject.value || [];
            this.publicFeedsSubject.next([...currentFeeds, ...feeds]);
          }
          this.publicLoadingSubject.next(false);
        },
        (error) => {
          this.publicLoadingSubject.next(false);
          this.publicErrorSubject.next(true);
        }
      );
  }

  getAllFeeds(eventId: string, limit: number, page: number): void {
    let params = new HttpParams();
    params = params.append("limit", limit.toString());
    params = params.append("page", page.toString());

    this.http
      .get(`${environment.BASE_URL}/feeds/event/feed/${eventId}`, { params })
      .pipe(map((response: any) => response.data || []))
      .subscribe(
        (feeds) => {
          if (feeds.length === 0) {
            this.noMoreFeedsSubject.next(true);
          } else {
            this.noMoreFeedsSubject.next(false);
            const currentFeeds = this.feedsSubject.value || [];
            this.feedsSubject.next([...currentFeeds, ...feeds]);
          }
          this.loadingSubject.next(false);
        },
        (error) => {
          this.loadingSubject.next(false);
          this.errorSubject.next(true);
        }
      );
  }

  updateFeeds(newFeed: any) {
    const currentFeeds = this.feedsSubject.value;
    this.feedsSubject.next([newFeed, ...currentFeeds]);
  }
  removeFeed(feedId: string) {
    const currentFeeds = this.feedsSubject.value;
    const updatedFeeds = currentFeeds.filter((feed) => feed._id !== feedId);
    this.feedsSubject.next(updatedFeeds);
  }
  getTotalPages(): number {
    return this.totalPages;
  }

  removeFeedFromSubject(feedId: string): void {
    const currentFeeds = this.feedsSubject.getValue();
    const updatedFeeds = currentFeeds.filter((feed) => feed._id !== feedId);
    this.feedsSubject.next(updatedFeeds);
  }
  // addFeedToSubject(newFeed: any): void {
  //   const currentFeeds = this.feedsSubject.getValue();
  //   const updatedFeeds = [...currentFeeds, newFeed];
  //   this.feedsSubject.next(updatedFeeds);
  // }

  // addFeedToSubject(newFeed: any): void {
  //   const currentFeeds = this.feedsSubject.getValue();
  //   const updatedFeeds = [newFeed, ...currentFeeds];
  //   this.feedsSubject.next(updatedFeeds);
  // }

  addFeedToSubject(newFeed: any): void {
    const currentFeeds = this.feedsSubject.getValue();
    this.feedsSubject.next([newFeed, ...currentFeeds]);
  }

  // addFeedToSubject2(newFeed: any): void {
  //   const currentFeeds = this.feedsSubject.getValue();
  //   currentFeeds.unshift(newFeed);
  //   this.feedsSubject.next(currentFeeds);
  // }
  // addFeedToSubject3(newFeed: any): void {
  //   const currentFeeds = this.feedsSubject.getValue();
  //   currentFeeds.unshift(newFeed);
  //   this.feedsSubject.next([...currentFeeds]); // Ensure the BehaviorSubject is updated correctly
  // }

  getAllFeedComments(feedId: string): Observable<any> {
    return this.http.get(`${environment.BASE_URL}/feeds/${feedId}/comments`);
  }

  postFeed(eventId: string, guestCode: string, payload: any): Observable<any> {
    return this.http.post(
      `${environment.BASE_URL}/feeds/${eventId}/guests/${guestCode}/feeds`,
      payload
    );
  }
  updateFeed(
    feedId: any,
    eventId: string,
    guestCode: string,
    payload: any
  ): Observable<any> {
    return this.http.patch(
      `${environment.BASE_URL}/feeds/${feedId}/${eventId}/${guestCode}`,
      payload
    );
  }
  deleteFeed(feedId: any, eventId: string, guestCode: string): Observable<any> {
    return this.http.delete(
      `${environment.BASE_URL}/feeds/${feedId}/${eventId}/${guestCode}`
    );
  }

  postUserFeed(eventId: string, payload: any): Observable<any> {
    return this.http.post(
      `${environment.BASE_URL}/users/user-create-feed/${eventId}`,
      payload
    );
  }
  commentUserFeed(
    eventId: string,
    feedId: string,
    payload: any
  ): Observable<any> {
    return this.http.post(
      `${environment.BASE_URL}/users/${eventId}/usercomment/${feedId}`,
      payload
    );
  }
  // /feeds/rfyfy/comment/yttyty/ffyf
  commentOnFeed(
    eventId: string,
    guestCode: string,
    feedId: string,
    payload: any
  ): Observable<any> {
    return this.http.post(
      `${environment.BASE_URL}/feeds/${feedId}/comment/${eventId}/${guestCode}`,
      payload
    );
  }
  // /feeds/r55/like/e555/rr
  likeFeed(
    feedId: string,
    eventId: string,
    guestCode: string
  ): Observable<any> {
    return this.http.post(
      `${environment.BASE_URL}/feeds/${feedId}/like/${eventId}/${guestCode}`,
      null
    );
  }
  unlikeFeed(
    feedId: string,
    eventId: string,
    guestCode: string
  ): Observable<any> {
    return this.http.post(
      `${environment.BASE_URL}/feeds/${feedId}/unlike/${eventId}/${guestCode}`,
      null
    );
  }
  // // Demo unlike method
  // unlikeFeedDemo(postId: string, eventId: string, guestCode: string) {
  //   // Simulate a successful server response after a short delay
  //   return of({ success: true }).pipe(delay(300));
  // }
  setGuestDetails(details: any): void {
    localStorage.setItem(this.GUEST_DETAILS_KEY, JSON.stringify(details));
  }
  setGuestInfo(details: any): void {
    localStorage.setItem(this.GUEST_INFO, JSON.stringify(details));
  }

  getGuestDetails(): any {
    const storedDetails = localStorage.getItem(this.GUEST_DETAILS_KEY);
    return storedDetails ? JSON.parse(storedDetails) : null;
  }
  getGuestInfo(): any {
    const storedDetails = localStorage.getItem(this.GUEST_INFO);
    return storedDetails ? JSON.parse(storedDetails) : null;
  }
  savePostAsDraft(details: any): void {
    localStorage.setItem(this.draft_post, JSON.stringify(details));
  }

  getDraftPost(): any {
    const storedDetails = localStorage.getItem(this.draft_post);
    return storedDetails ? JSON.parse(storedDetails) : null;
  }

  clearDraftPost(): void {
    localStorage.removeItem(this.draft_post);
  }
  saveEventPostAsDraft(details: any): void {
    localStorage.setItem(this.event_draft_post, JSON.stringify(details));
  }

  getEventDraftPost(): any {
    const storedDetails = localStorage.getItem(this.event_draft_post);
    return storedDetails ? JSON.parse(storedDetails) : null;
  }

  clearEventDraftPost(): void {
    localStorage.removeItem(this.event_draft_post);
  }
  upload = (payload) =>
    this.http.post(`${environment.BASE_URL}/uploads/upload`, payload, {
      reportProgress: true,
      observe: "events",
    });

  isLoggedIn(): boolean {
    return !!this.getGuestDetails();
  }

  logout(): void {
    localStorage.removeItem(this.GUEST_DETAILS_KEY);
    localStorage.removeItem(this.GUEST_INFO);
  }

  revokeGuest(payload): Observable<any> {
    return this.http.put<any>(
      `${environment.BASE_URL}/events/guest/revoke-guests`,
      payload
    );
  }
  getAttires(eventCode): Observable<any> {
    return this.http.get<any>(
      `${environment.BASE_URL}/events/event/event-attire/${eventCode}`
    );
  }
  requestAttire(payload): Observable<any> {
    return this.http.post(
      `${environment.BASE_URL}/events/request-attire`,
      payload
    );
  }
}
